import {useRef} from 'react';
import {createArticleWorkspace} from './articleWorkspace.js';

export function useArticleWorkspace(ports) {
  const latest = useRef(ports);
  latest.current = ports;
  const workspace = useRef();
  if (!workspace.current) workspace.current = createArticleWorkspace({
    context: () => latest.current.context(),
    update: patch => latest.current.update(patch),
    storage: sessionStorage,
    readURL: () => new URL(location.href),
    writeURL: (url, mode) => window.history[mode === 'push' ? 'pushState' : 'replaceState']({}, '', url),
    focus: target => requestAnimationFrame(() => latest.current.focus(target)),
    scroll: (target, top) => latest.current.scroll(target, top),
    readDrafts: (...args) => latest.current.readDrafts(...args)
  });
  return workspace.current;
}
